<div class="wrapper">
    <div class="mrt-75">
        <div class="page-title">
            <label class="page-caption" style="color: white;">Privileges</label>
        </div>
        <div class="add-button-box">
            <div class="col-md-12">
                <button (click)="onAddClick()" class="add-button hand-link">Add Privilege</button>
            </div>
        </div>
        
        <div class="row" *ngIf="privilegesList.length > 0 && gridOptions">
        <ag-grid-angular class="ag-theme-balham grid"
            [rowData]="gridOptions.rowData" [columnDefs]="gridOptions.columnDefs" [defaultColDef]="gridOptions.defaultColDef"
            [domLayout]="domLayout"
            (gridReady)="onGridReady($event)">
        </ag-grid-angular>
        </div>
        <div class="row" *ngIf="privilegesList.length === 0 && gridOptions">
          <div class="col-12 text-center" style="padding: 40px;">
            <h4>No Privileges Found</h4>
          </div>
        </div>
        
        <ng-template #addPrivilege let-c="close" let-d="dismiss">
            <div class="modal-header blue-bg" style="padding:10px !important;">
                <h2 class="modal-title" style="margin:0px !important" id="modal-basic-title">{{popupHeading}}</h2>
                <button type="button" style="color: white;" class="close" (click)="d('Close click')">&times;</button>
              </div>
              <div class="modal-body">
                <div class="col-md-12">
                    <label class="name">Privilege Name</label>
                    <input class="form-control" maxlength="51" type="text" [(ngModel)]="privilegeName"/>
                </div>
                <div class="col-md-12">
                    <p *ngIf="privilegeName.length==0" class="validation-text">Please enter privilege name</p>
                    <p *ngIf="privilegeName.length>50" class="validation-text">Privilege name should be equal or less than 50 characters</p>
                </div>
              </div>
                <div class="modal-footer">
                    <button type="button" class="btn add-button custom-btn" (click)="savePrivilege()">Save</button>
                    <button type="button" class="btn cancel-btn" (click)="c('Close click')">Cancel</button>
                  </div>
        </ng-template>
    </div>

    </div>